export default {
  popupTitle: {
    id: 'product_page_visible_by_verizon_popup_title',
    defaultMessage: 'Get an exclusive Visible promo code with this phone.',
  },
  logo: {
    id: 'product_page_visible_by_verizon_popup_logo_alt',
    defaultMessage: 'Visible by Verizon',
  },
  popupBody: {
    id: 'product_page_visible_by_verizon_popup_body',
    defaultMessage:
      "Pair this phone with a Visible plan and get exclusive pricing for unlimited 5G and 4G LTE data on Verizon's network with no hidden fees or contracts. Apply the code at checkout on the Visible site.",
  },
  stepsTitle: {
    id: 'product_page_visible_by_verizon_popup_steps_title',
    defaultMessage: 'How to activate your savings',
  },
  step1: {
    id: 'product_page_visible_by_verizon_popup_step1',
    defaultMessage: 'Buy any unlocked phone on Back Market.',
  },
  step2: {
    id: 'product_page_visible_by_verizon_popup_step2',
    defaultMessage: 'Get the promo code in your confirmation email.',
  },
  step3: {
    id: 'product_page_visible_by_verizon_popup_step3',
    defaultMessage: 'Use your code when subscribing to the Visible+ plan.',
  },
  closeButtonLabel: {
    id: 'product_page_visible_by_verizon_popup_close_button_label',
    defaultMessage: 'Close "Visible by Verizon" popup',
  },
}
